import { SET_DEMO_MODE } from '../actions/set-demo-mode';

export default function experiments(state = false, action) {
  switch (action.type) {
    case SET_DEMO_MODE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/is-demo-mode.js